import KendoHOC from "./utils/KendoHOC";

const Textarea = (options) => (KendoHOC("textarea", options));

export default Textarea;
